import { useMemo } from 'react';

import { q } from '@actual-app/core/shared/query';

import { useQuery } from '#hooks/useQuery';

/**
 * Ingresos del mes sin categoría (en céntimos), en vivo: entradas de cuentas
 * del presupuesto que no son traspasos internos y no llevan categoría. En el
 * modelo de sobres no cuentan para «Listo para asignar» hasta que se les pone
 * una categoría de ingreso, así que el sueldo «desaparece» si nadie avisa.
 * Los divididos cuentan por sus partes (las que no tengan categoría). Lo
 * que aún está por revisar no cuenta aquí: ya sale en «Revisar» (Vadik,
 * 26-oct-2026: categorizar es parte de revisar, no otra fila).
 */
export function useIngresosSinCategoria(mes: string): {
  importe: number;
  cargando: boolean;
} {
  const { data, isLoading } = useQuery<{ id: string; amount: number }>(
    () =>
      q('transactions')
        .options({ splits: 'inline' })
        .filter({
          category: null,
          reviewed: true,
          amount: { $gt: 0 },
          date: { $transform: '$month', $eq: mes },
          'account.offbudget': false,
          $or: [
            { 'payee.transfer_acct': null },
            { 'payee.transfer_acct.offbudget': true },
          ],
        })
        .select(['id', 'amount']),
    [mes],
  );
  const importe = useMemo(
    () => (data ?? []).reduce((s, m) => s + m.amount, 0),
    [data],
  );
  return { importe, cargando: isLoading };
}
